module.exports = __webpack_public_path__ + "img/1 - Slow Shutter.7bbe8a24.jpeg";